<p-toast />
<div
  class="flex items-center justify-center"
  [style.height]="'calc(100svh - var(--env-banner-height, 0px))'"
  [style.maxHeight]="'calc(100svh - var(--env-banner-height, 0px))'"
>
  @if(this.state === 'email') {
  <p-card>
    <div class="flex justify-center p-5">
      <img
        src="pkvverlag_logo.png"
        class="max-w-[100px]"
      >
    </div>
    <form
      [formGroup]="this.emailForm"
      (ngSubmit)="this.onNext()"
      class="flex flex-col gap-4 w-full"
    >
      <div class="flex flex-col items-center gap-1">
        <input
          pInputText
          fluid
          size="small"
          type="email"
          id="email"
          placeholder="Email"
          formControlName="email"
          [invalid]="isInvalid('email')"
        />
        @if (this.isInvalid('email')) {
        @if (this.emailForm.get('email')?.errors?.['required']) {
        <p-message
          severity="error"
          size="small"
          variant="simple"
        >Email ist ein Pflichtfeld.</p-message>
        }
        @if (this.emailForm.get('email')?.errors?.['email']) {
        <p-message
          severity="error"
          size="small"
          variant="simple"
        >Email Adresse ist ungültig.</p-message>
        }
        }
      </div>
      <button
        pButton
        severity="secondary"
        type="submit"
        size="small"
        [disabled]="this.isInvalid('email') || this.emailForm.pristine"
      ><span pButtonLabel>Einloggen</span></button>
    </form>
  </p-card>
  }
  @else if (this.state === 'pin') {
  <p-card>
    <div class="flex justify-center p-5">
      <img
        src="pkvverlag_logo.png"
        class="max-w-[100px]"
      >
    </div>
    <form
      [formGroup]="this.pinForm"
      (ngSubmit)="this.onSubmit()"
      class="flex flex-col gap-4"
    >
      <div class="flex flex-col gap-1">
        <p-inputotp
          formControlName="pin"
          [length]="6"
          [invalid]="isInvalid('pin')"
        />
        @if (this.isInvalid('pin')) {
        <p-message
          severity="error"
          size="small"
          variant="simple"
        >PIN ist ein Pflichtfeld.</p-message>
        }
      </div>
      <button
        pButton
        severity="secondary"
        type="submit"
      ><span pButtonLabel>Bestätigen</span></button>
    </form>
  </p-card>
  }
</div>